import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unserviceable',
  templateUrl: './unserviceable.component.html',
  styleUrls: ['./unserviceable.component.css']
})
export class UnserviceableComponent implements OnInit {
  restaurant: any;
  constructor() { }

  ngOnInit() {
    this.restaurant = JSON.parse(localStorage.getItem("selectedRestaurant"));

  }

}
